import { useDeploymentInfo } from '~/config/useDeploymentInfo';
import { buildProductImageUrl, buildPromoImageUrl } from './imageUrlBuilder';

export function useProductImageUrl(celumId: number | undefined) {
  const { DEPLOYMENT_ENVIRONMENT } = useDeploymentInfo();

  if (celumId === undefined) {
    return '';
  }
  return buildProductImageUrl(celumId, { env: DEPLOYMENT_ENVIRONMENT });
}

export function usePromoImageUrl(celumId: number) {
  const { DEPLOYMENT_ENVIRONMENT } = useDeploymentInfo();

  if (celumId === undefined) {
    return '';
  }
  return buildPromoImageUrl(celumId, { env: DEPLOYMENT_ENVIRONMENT });
}
